<template>
  <div class="nav-item">
    <header class="header">
      <div class="nav-section">
        <span class="nav-item active">Dashboard</span>
        <span class="nav-item">Overview</span>
      </div>
      <div class="user-section">
        <div class="notification">
          <i class="fas fa-bell"></i>
          <span class="notification-badge"></span>
        </div>

        <div class="user-dropdown" @click="toggleDropdown">
          <div class="user-profile">
            <span>{{ userFullName }}</span>
            <div class="avatar">{{ getUserInitials() }}</div>
            <i class="fas fa-chevron-down dropdown-icon" :class="{ 'rotated': showDropdown }"></i>
          </div>

          <div v-if="showDropdown" class="dropdown-menu">
            <div class="dropdown-item" @click="goToDashboard">
              <i class="fas fa-tachometer-alt"></i>
              <span>Dashboard</span>
            </div>
            <div class="dropdown-item" @click="logout">
              <i class="fas fa-sign-out-alt"></i>
              <span>Logout</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>
<style scoped>
.user-dropdown {
  position: relative;
  cursor: pointer;
}

.dropdown-icon {
  margin-left: 0.5rem;
  font-size: 0.8rem;
  transition: transform 0.2s ease;
}

.dropdown-icon.rotated {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 180px;
  z-index: 1000;
  margin-top: 0.5rem;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  font-size: 0.9rem;
  color: #333;
  transition: background-color 0.2s ease;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}

.dropdown-item:first-child {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.dropdown-item:last-child {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.dropdown-item i {
  margin-right: 0.75rem;
  width: 16px;
  color: #666;
}

.dropdown-item:hover i {
  color: #007bff;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #007bff;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 500;
  margin-left: 0.5rem;
}

.sidebar-item i {
  width: 20px;
  color: #004aad !important;
}

.sidebar-item.active i {
  color: #fff;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 2rem;
  background-color: #fff;
  position: absolute;
  left: 17%;
  width: 83%;
  top: 1%;
}

.nav-section {
  display: flex;
  gap: 2rem;
}

.nav-item {
  left: 16%;
  padding: 0.5rem 0;
  cursor: pointer;
  color: #555;
  font-size: 0.9rem;
}

.nav-item.active {
  font-weight: 500;
  color: #007bff;
  border-bottom: 2px solid #007bff;
}

.user-section {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.notification {
  position: relative;
  color: #777;
}

.notification-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  background-color: #ff4d4d;
  border-radius: 50%;
  border: 1px solid white;
}

.user-profile {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.user-profile span {
  font-size: 0.9rem;
  color: #333;
}
.sidebar-item img {
  width: 20px;
  height: auto;
  vertical-align: middle;
  filter: grayscale(100%);
  opacity: 0.8;
}

.sidebar-item.active img {
  filter: grayscale(0%);
  opacity: 1;
}
.main-content {
  flex: 1;
  padding: 1.5rem 2rem;
  overflow-y: auto;
  background-color: #f0f2f5;
  margin-left: 220px;
}

.overview-section {
  background-color: #fff;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.25rem;
}

.icon-container {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
}

.blue {
  background-color: #007bff;
}
.light-blue {
  background-color: #e0f7fa;
  color: #007bff;
}
.light-blue i {
  color: #007bff;
}
.metric-timestamp i {
  font-size: 6px;
  vertical-align: middle;
  margin-right: 0.2rem;
}
.section-header h2 {
  flex: 1;
  font-size: 1.2rem;
  color: #333;
  font-weight: 500;
}
.actions i {
  cursor: pointer;
}
table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding: 0.85rem 1rem;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
  font-size: 0.85rem;
  color: #555;
}

th {
  font-weight: 500;
  color: #777;
  background-color: #f8f8f8;
}
th:first-child, td:first-child {
  padding-left: 1.5rem;
}
th:last-child, td:last-child {
  padding-right: 1.5rem;
  text-align: center;
}

.action-icon {
  color: #007bff;
  cursor: pointer;
  font-size: 1rem;
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 1.25rem;
  font-size: 0.85rem;
  color: #777;
}

.pagination > * {
  margin: 0 0.75rem;
}

.pagination span, .pagination select {
  margin-right: 0.75rem;
}

.pagination select {
  padding: 0.3rem 0.5rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 0.85rem;
  color: #555;
}

.pagination-controls i {
  cursor: pointer;
  padding: 0.3rem 0.6rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.8rem;
  background-color: #fff;
  color: #555;
  transition: background-color 0.2s, color 0.2s;
}
.pagination-controls i:hover {
  background-color: #f0f0f0;
}
</style>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'NavItem',
  data() {
    return {
      showDropdown: false,
    };
  },
  computed: {
    ...mapGetters({
      authenticatedUser: 'auth/authenticatedUser',
    }),
    userFullName() {
      return this.authenticatedUser?.userFullName || 'Admin User';
    },
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    getUserInitials() {
      if (!this.userFullName) return 'AU';
      return this.userFullName
        .split(' ')
        .map((name) => name.charAt(0).toUpperCase())
        .join('')
        .substring(0, 2);
    },
    goToDashboard() {
      this.showDropdown = false;
      this.$router.push({ name: 'Dashboard' });
    },
    async logout() {
      this.showDropdown = false;
      try {
        await this.$store.dispatch('auth/signOut');
        this.$router.push({ name: 'SignIn' });
      } catch {
        this.$toast.error('Logout failed. Please try again.');
      }
    },
  },
  mounted() {
    document.addEventListener('click', (event) => {
      if (!this.$el.contains(event.target)) {
        this.showDropdown = false;
      }
    });
  },
};
</script>
